import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CreatePlantingAdvicePayload } from '../../../recommendations/types';
import api from '../../http';
import { toApiError } from '../utils';
import { useForBindingId } from '../../../forBinding';

export function usePostAdviceCorrectionCreate() {
	const queryClient = useQueryClient();
	const forBinding = useForBindingId();
	return useMutation<any, Error, CreatePlantingAdvicePayload>({
		mutationFn: async (payload) => {
			try {
				const { data } = await api.post('/advices/planting/store', payload, {
					params: { forBinding },
				});
				return data;
			} catch (error) {
				throw toApiError(error, 'Erro ao criar a recomendação de correção');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['correction'] });
		},
	});
}
